<template>
  <el-dialog
    :title="form.id ? '编辑' : '新建'"
    :visible.sync="formVisible"
    width="1100px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="dataForm"
      :rules="formRules"
      :model="form"
      label-position="right"
      size="small"
      label-width="100px"
    >
      <el-card class="box-card">
        <el-descriptions title="内容类型(必填)"></el-descriptions>
        <el-button
          :class="
            item.value === activeType
              ? 'content-type-btn active'
              : 'content-type-btn'
          "
          :disabled="!!form.id"
          v-for="(item, index) in contentTypes"
          :key="index"
          @click="handleContentTypeChange(item.value)"
          >{{ item.label }}</el-button
        >
      </el-card>
      <el-card class="box-card mt10" v-if="activeType !== 4">
        <el-descriptions title="文章基础消息"></el-descriptions>
        <el-form-item label="基础信息" class="width100">
          <div style="display: flex;">
            <imageUpload v-model="form.coverImage" width="120" height="80" />
            <div style="margin-left: 10px;width: 100%;">
              <el-form-item prop="title" class="width100">
                <el-input v-model="form.title" placeholder="请输入标题" />
              </el-form-item>
              <el-form-item prop="description" class="width100">
                <el-input v-model="form.description" placeholder="请输入描述" />
              </el-form-item>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="分享海报图片" prop="posterImg" class="width100">
          <moreImageUpload
            v-model="form.posterImg"
            :limit="999"
            hintText="建议尺寸750x750像素以上"
          />
        </el-form-item>
        <el-form-item label="分类" prop="classificationId">
          <treeselect
            v-model="form.classificationId"
            :options="menuOptions"
            :normalizer="normalizer"
            :show-count="true"
            noOptionsText="暂无数据"
            placeholder="请选择"
          />
        </el-form-item>
        <el-form-item label="排序" prop="orderNo">
          <el-input v-model="form.orderNo" placeholder="请输入排序值" />
        </el-form-item>
        <el-form-item label="虚拟数据配置" prop="virtualData" class="width100">
          <div class="virtual-data-container">
            <el-form-item label="浏览量: " label-width="80px" prop="browseNum">
              <el-input
                v-model="form.browseNum"
                placeholder="请输入虚拟浏览量"
              />
            </el-form-item>
            <el-form-item label="点赞量: " label-width="80px" prop="likeNum">
              <el-input v-model="form.likeNum" placeholder="请输入虚拟点赞量" />
            </el-form-item>
            <el-form-item label="收藏量: " label-width="80px" prop="collectNum">
              <el-input
                v-model="form.collectNum"
                placeholder="请输入虚拟收藏量"
              />
            </el-form-item>
            <el-form-item label="转发量: " label-width="80px" prop="forwardNum">
              <el-input
                v-model="form.forwardNum"
                placeholder="请输入虚拟转发量"
              />
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="state" class="width100">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-card>
      <!-- 线下/课程：课程基础信息 -->
      <el-card class="box-card mt10" v-if="activeType === 4">
        <el-descriptions title="课程基础信息"></el-descriptions>
        <el-form-item label="课程：" prop="courseSubjectId">
          <el-select
            v-model="form.courseSubjectId"
            placeholder="请选择课程"
            filterable
            clearable
            remote
            :remote-method="searchCourse"
            :loading="courseLoading"
            @change="handleCourseChange"
            style="width: 100%"
          >
            <el-option
              v-for="item in courseOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类：" prop="classificationId">
          <treeselect
            v-model="form.classificationId"
            :options="menuOptions"
            :normalizer="normalizer"
            :show-count="true"
            noOptionsText="暂无数据"
            placeholder="请选择分类"
          />
        </el-form-item>
        <el-form-item label="排序" prop="orderNo">
          <el-input v-model="form.orderNo" placeholder="请输入排序值" />
        </el-form-item>
        <el-form-item label="状态" prop="state" class="width100">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-card>
      <!-- 线下物料的网盘信息：沿用既有 otherName/otherUrl 两列，提取码是本需求新增的 otherCode 列 -->
      <el-card class="box-card mt10" v-if="activeType === 3">
        <el-descriptions title="网盘信息"></el-descriptions>
        <el-form-item
          label="网盘名称: "
          prop="otherName"
          label-width="90px"
          class="width100"
        >
          <el-input v-model="form.otherName" placeholder="如：百度网盘" />
        </el-form-item>
        <el-form-item
          label="分享链接: "
          prop="otherUrl"
          label-width="90px"
          class="width100"
        >
          <el-input
            v-model="form.otherUrl"
            placeholder="请输入网盘分享链接"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
        <el-form-item
          label="提取码: "
          prop="otherCode"
          label-width="90px"
          class="width100"
        >
          <el-input
            v-model="form.otherCode"
            placeholder="没有提取码可留空，App 端会只复制链接"
            maxlength="32"
          />
        </el-form-item>
      </el-card>
      <!-- 线下/课程：课程信息 -->
      <el-card class="box-card mt10" v-if="activeType === 4">
        <div class="course-info-header">
          <div class="course-info-title">课程信息</div>
          <div class="course-attachment-tip">
            附件:支持上传类型:PPT, PDF, word, Excel,文件夹,压缩包,
          </div>
        </div>
        <el-form-item
          label="上传课程："
          prop="courseChapterList"
          class="width100"
        >
          <div class="table-list mt20">
            <div class="spec-head">
              <div class="sp-col">章节节数</div>
              <div class="sp-col">章节名称</div>
              <div class="sp-col">附件</div>
              <div class="sp-col flex05">操作</div>
            </div>
            <div
              class="spec-item"
              v-for="(item, idx) in courseChapterList"
              :key="idx"
            >
              <el-form-item class="sp-col" label-width="0">
                <el-input
                  :value="idx + 1"
                  disabled
                  style="text-align: center;"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="sp-col"
                label-width="0"
                :rules="{
                  required: true,
                  message: '请选择',
                  trigger: 'change'
                }"
              >
                <el-select
                  v-model="item.chapterId"
                  placeholder="请选择"
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="chapter in availableChapters"
                    :key="chapter.id"
                    :label="chapter.name"
                    :value="chapter.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="sp-col" label-width="0">
                <el-button
                  size="small"
                  @click="handleUploadChapterAttachment(idx)"
                  >上传附件 (选填)</el-button
                >
                <div
                  v-if="item.attachmentFiles && item.attachmentFiles.length > 0"
                  style="margin-top: 5px;"
                >
                  <el-tag
                    v-for="(file, fileIdx) in item.attachmentFiles"
                    :key="fileIdx"
                    closable
                    @close="handleRemoveChapterFile(idx, fileIdx)"
                    style="margin-right: 5px;"
                  >
                    {{ file.name || file.url }}
                  </el-tag>
                </div>
              </el-form-item>
              <div class="sp-col oper-icon flex05">
                <i
                  class="el-icon-minus"
                  @click="handleDeleteChapter(idx)"
                  v-if="courseChapterList.length > 1"
                ></i>
                <i class="el-icon-plus" @click="handleAddChapter"></i>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-card>

      <el-card class="box-card mt10" v-if="activeType === 3">
        <el-descriptions title="文章详情" />
        <!--
          BUG-2026-327119：线下物料（type 3）用「一个富文本编辑器」，图片/文字/视频
          都在里面排版，App 端（线下物料详情页）直接把这段 HTML 渲染出来。
          编辑器本身是 TinyMCE，已内置 image / media 插件，可直接插图和视频。

          BUG-2026-591741：线上资料（type 1）不需要这个富文本编辑框 —— 线上资料在
          App/H5 端只展示图片网格 + 分享文案，从不渲染 content，运营填了也用不上。
          所以条件从 activeType !== 4（线上+线下都显示）收窄为 activeType === 3（仅线下）。
        -->
        <el-form-item label="内容" prop="content" class="width100">
          <editor
            :key="editorKey"
            v-model="form.content"
            :min-height="240"
            :height="240"
            :uploadUrl="uploadUrl"
          />
        </el-form-item>
      </el-card>
      <!-- 只有线上资料(1)有这块。线下物料(3)的「物料预览图」已去掉：
           它的图靠上面那个富文本编辑器直接排版，不再单独维护一组预览图+图片说明。 -->
      <el-card class="box-card mt10" v-if="activeType === 1">
        <el-descriptions
          title="资料包内容（图片 + 推荐文案）"
        ></el-descriptions>
        <el-form-item
          label="下载素材权限"
          prop="canDownloadMaterial"
          class="width100"
        >
          <el-radio-group v-model="form.canDownloadMaterial">
            <el-radio :label="0">不允许用户下载素材</el-radio>
            <el-radio :label="1">允许用户下载素材</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分享文案：" class="width100">
          <el-tag
            :key="`tag-${index}`"
            v-for="(tag, index) in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag, index)"
          >
            {{ index + 1 }}、{{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >添加文案</el-button
          ></el-form-item
        >
        <el-form-item
          label="资料包图片"
          prop="shareImage"
          class="width100"
        >
          <moreImageUpload
            v-model="form.materialImg"
            :limit="999"
            hintText="建议尺寸750x750像素以上；上传后可在下方逐张填写标题与说明"
          />
        </el-form-item>
        <!--
          逐张图片的标题/说明直接挂在 materialImg 这个 JSON 数组的元素上（{url,name,title,description}），
          不新增数据库列。App 端线上资料包详情按图展示标题+说明，线下物料按标题做分栏预览。
        -->
        <el-form-item
          label="图片说明"
          class="width100"
          v-if="form.materialImg && form.materialImg.length"
        >
          <div class="table-list">
            <div class="spec-head">
              <div class="sp-col flex05">预览</div>
              <div class="sp-col">标题</div>
              <div class="sp-col">说明</div>
            </div>
            <div
              class="spec-item"
              v-for="(img, imgIdx) in form.materialImg"
              :key="`img-${imgIdx}`"
            >
              <div class="sp-col flex05">
                <el-image
                  :src="img.url"
                  fit="cover"
                  style="width: 60px; height: 60px;"
                />
              </div>
              <div class="sp-col">
                <el-input
                  :value="img.title"
                  placeholder="如：焕活肌肤·焕新由内而外"
                  size="small"
                  @input="val => setImgField(imgIdx, 'title', val)"
                />
              </div>
              <div class="sp-col">
                <el-input
                  :value="img.description"
                  placeholder="图片下方的小字说明"
                  size="small"
                  @input="val => setImgField(imgIdx, 'description', val)"
                />
              </div>
            </div>
          </div>
        </el-form-item>
      </el-card>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import templateClassificationApi from "@/api/marketing/templateClassification";
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";
import courseSubjectApi from "@/api/course/courseSubject";
import courseClassificationApi from "@/api/course/courseClassification";
import courseSubjectVideoApi from "@/api/course/courseSubjectVideo";
import ImageUpload from "@/components/ImageUpload";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Editor from "@/components/Editor";
import MoreImageUpload from "@/components/MoreImageUpload";
import FileUpload from "@/components/FileUpload";
function initFormBean() {
  const formBean = {
    id: null,
    classificationId: null,
    classificationCode: "",
    coverImage: null,
    title: null,
    titleJson: null,
    description: null,
    type: 1,
    orderNo: 0,
    state: 1,
    // 虚拟数据默认 0：绝大多数资料包不需要造数据，必填会逼运营手敲四个 0
    browseNum: 0,
    likeNum: 0,
    collectNum: 0,
    forwardNum: 0,
    logolmg: null,
    content: "",
    canDownloadMaterial: null,
    materialImg: [],
    materialText: [],
    otherName: null,
    otherUrl: null,
    otherCode: null,
    meetingId: null,
    contactTime: null,
    contactAddress: null,
    contactName: null,
    contactPho: null,
    teacherId: null,
    teacherIsEdit: 0,
    courseSubjectId: null,
    courseSubjectList: null,
    courseClassificationList: [],
    sourceType: 10,
    attachmentFiles: [],
     // 分享素材图片（多张图片，前端用数组存，提交时转成逗号分隔字符串）
     posterImg: [],
  };
  return formBean;
}

export default {
  components: { ImageUpload, Treeselect, Editor, MoreImageUpload, FileUpload },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload",
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        contentType: [
          { required: true, message: "请选择内容类型", trigger: "change" }
        ],
        classificationId: [
          { required: true, message: "请输入分类", trigger: "blur" }
        ],
        otherName: [{ message: "请输入名称", trigger: "blur" }],
        otherUrl: [{ message: "请输入链接", trigger: "blur" }],
        coverImage: [
          { required: true, message: "请上传封面图", trigger: "change" }
        ],
        orderNo: [
          { required: true, message: "排序不能为空", trigger: "change" },
          { pattern: /^[0-9]*$/, message: "排序必须为数字值", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        // 虚拟数据不必填（默认 0），但填了必须是数字
        browseNum: [{ pattern: /^[0-9]*$/, message: "虚拟浏览量必须为数字", trigger: "blur" }],
        likeNum: [{ pattern: /^[0-9]*$/, message: "虚拟点赞量必须为数字", trigger: "blur" }],
        collectNum: [{ pattern: /^[0-9]*$/, message: "虚拟收藏量必须为数字", trigger: "blur" }],
        forwardNum: [{ pattern: /^[0-9]*$/, message: "虚拟转发量必须为数字", trigger: "blur" }],
        courseSubjectId: [
          { required: true, message: "请选择课程", trigger: "change" }
        ],
        courseChapterList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.activeType === 4) {
                if (
                  !this.courseChapterList ||
                  this.courseChapterList.length === 0
                ) {
                  callback(new Error("请至少添加一个章节"));
                } else {
                  const hasEmptyChapter = this.courseChapterList.some(
                    item => !item.chapterId
                  );
                  if (hasEmptyChapter) {
                    callback(new Error("请选择所有章节名称"));
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      isRepSub: false,
      activeType: 1,
      // 项目落地只有线上/线下两种资料包，沿用既有 type 值域（1线上图文 / 3线下文件），不新增值
      contentTypes: [
        { label: "线上资料", value: 1 },
        { label: "线下物料", value: 3 }
      ],
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      menuOptions: [],
      isParentid: false,
      editorKey: 0,
      // 附件文件列表
      attachmentFiles: [],
      // 线下/课程相关
      courseOptions: [],
      courseClassOptions: [],
      courseLoading: false,
      categorizepProps: {
        value: "id",
        label: "typeName",
        children: "courseClassificationVO",
        multiple: true,
        emitPath: false
      },
      courseChapterList: [{ chapterId: null, attachmentFiles: [] }],
      availableChapters: [],
      currentUploadChapterIndex: null
    };
  },
  watch: {
    // 线上/线下现在共用同一个富文本编辑器，切类型时只需要强制重挂 Editor，
    // 不再维护 type 3 的多模块 contentList。
    activeType() {
      this.editorKey += 1;
    }
  },
  created() {
    this.getTreeselect();
    this.getCourseOptions();
    this.getCourseClassOptions();
  },
  methods: {
    /**
     * 给 materialImg 数组里的某张图补标题/说明。
     * MoreImageUpload 吐出来的元素是 {url,name}，这里再挂 title/description，
     * 整个数组会被 doCreate() 原样 JSON.stringify 进 material_img 列，不需要加表列。
     */
    setImgField(index, field, value) {
      const item = this.form.materialImg[index];
      if (!item) return;
      this.$set(item, field, value);
    },
    /** 处理内容类型切换 */
    handleContentTypeChange(value) {
      // 编辑模式下不允许更改内容类型
      if (this.form.id) {
        this.$message.warning("编辑模式下不允许更改内容类型");
        return;
      }
      this.activeType = value;
      // BUG-2026-591741：线上资料没有富文本框，切到线上时把可能已填的 content 清掉，
      // 避免把用不上的富文本内容跟着一起提交入库。
      if (value !== 3) {
        this.form.content = "";
      }
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.childList && !node.childList.length) {
        delete node.childList;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.childList
      };
    },
    /** 查询分类下拉树结构 */
    getTreeselect() {
      templateClassificationApi
        .fetchTreeList({ pageNo: 1, pageSize: 1000, sourceType: 10, state: 1 })
        .then(({ data }) => {
          if (data && data.list) {
            this.menuOptions = data.list;
          } else {
            this.menuOptions = [];
          }
        })
        .catch(err => {
          console.error("获取分类树失败:", err);
          this.menuOptions = [];
        });
    },
    /**
     * 在树结构中根据id查找节点并返回code
     * @param {Array} tree 树结构数组
     * @param {Number|String} id 要查找的id
     * @returns {String|null} 找到的code值，未找到返回null
     */
    findCodeById(tree, id) {
      if (!tree || !Array.isArray(tree) || id === null || id === undefined) {
        return null;
      }
      for (const node of tree) {
        // 比较id，支持数字和字符串类型
        if (node.id === id || node.id === Number(id) || String(node.id) === String(id)) {
          return node.code || null;
        }
        // 递归查找子节点，兼容childList和children两种字段名
        const children = node.childList || node.children;
        if (children && Array.isArray(children) && children.length > 0) {
          const code = this.findCodeById(children, id);
          if (code !== null) {
            return code;
          }
        }
      }
      return null;
    },
    /** 获取课程选项 */
    getCourseOptions() {
      // 首次加载10条数据
      this.searchCourse("");
    },
    /** 远程搜索课程 */
    searchCourse(query) {
      this.courseLoading = true;
      const params = {
        pageNo: 1,
        pageSize: query ? 100 : 10, // 搜索时加载100条，首次加载10条
        isFreeAmount: -1,
        sourceType: 2,
        viewTemplate:1
      };
      if (query) {
        params.name = query;
      }
      courseSubjectApi
        .fetchList(params)
        .then(({ data }) => {
          if (data && data.list) {
            this.courseOptions = data.list;
          } else {
            this.courseOptions = [];
          }
        })
        .catch(err => {
          console.error("获取课程选项失败:", err);
          this.courseOptions = [];
        })
        .finally(() => {
          this.courseLoading = false;
        });
    },
    /** 获取课程分类选项 */
    getCourseClassOptions() {
      courseClassificationApi
        .fetchList({ pageNo: 1, pageSize: 1000, state: 1, categoryId: 2 })
        .then(({ data }) => {
          if (data && data.list) {
            this.courseClassOptions = this.formatCourseClassTree(data.list);
          } else {
            this.courseClassOptions = [];
          }
        })
        .catch(err => {
          console.error("获取课程分类失败:", err);
          this.courseClassOptions = [];
        });
    },
    /** 格式化课程分类树结构 */
    formatCourseClassTree(list) {
      return list.map(item => ({
        id: item.id,
        typeName: item.typeName,
        courseClassificationVO: item.courseClassificationVO
          ? this.formatCourseClassTree([item.courseClassificationVO])
          : null
      }));
    },
    /** 处理课程选择变化 */
    handleCourseChange(courseId) {
      if (courseId) {
        // 获取课程的章节列表
        courseSubjectVideoApi
          .fetchList({
            pageNo: 1,
            pageSize: 1000,
            subjectId: courseId
          })
          .then(({ data }) => {
            if (data && data.list) {
              this.availableChapters = data.list;
            } else {
              this.availableChapters = [];
            }
          })
          .catch(err => {
            console.error("获取章节列表失败:", err);
            this.availableChapters = [];
          });
      } else {
        this.availableChapters = [];
        // 清空章节列表
        this.courseChapterList = [{ chapterId: null, attachmentFiles: [] }];
      }
    },
    /** 添加上传章节 */
    handleAddChapter() {
      this.courseChapterList.push({
        chapterId: null,
        attachmentFiles: []
      });
    },
    /** 删除上传章节 */
    handleDeleteChapter(index) {
      if (this.courseChapterList.length > 1) {
        this.courseChapterList.splice(index, 1);
      } else {
        this.$message.warning("至少需要保留一个章节");
      }
    },
    /** 上传章节附件 */
    handleUploadChapterAttachment(index) {
      this.currentUploadChapterIndex = index;
      // 触发文件上传组件
      this.$nextTick(() => {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.multiple = true;
        fileInput.accept =
          ".ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar,.7z";
        fileInput.onchange = e => {
          const files = Array.from(e.target.files);
          if (!this.courseChapterList[index].attachmentFiles) {
            this.$set(this.courseChapterList[index], "attachmentFiles", []);
          }
          files.forEach(file => {
            this.courseChapterList[index].attachmentFiles.push({
              name: file.name,
              file: file,
              uid: Date.now() + Math.random()
            });
          });
        };
        fileInput.click();
      });
    },
    /** 移除章节文件 */
    handleRemoveChapterFile(chapterIndex, fileIndex) {
      this.courseChapterList[chapterIndex].attachmentFiles.splice(fileIndex, 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      const inputValue = this.inputValue && this.inputValue.trim();
      if (inputValue) {
        // 检查是否已存在，避免重复
        if (!this.dynamicTags.includes(inputValue)) {
          this.dynamicTags.push(inputValue);
          // 同步到 form.materialText
          if (!this.form.materialText) {
            this.form.materialText = [];
          }
          if (!this.form.materialText.includes(inputValue)) {
            this.form.materialText.push(inputValue);
          }
        } else {
          this.$message.warning("该文案已存在");
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleClose(tag, index) {
      // 使用 index 删除，更准确
      if (index !== undefined && index >= 0) {
        this.dynamicTags.splice(index, 1);
        // 同步从 form.materialText 中移除
        if (this.form.materialText && Array.isArray(this.form.materialText)) {
          this.form.materialText.splice(index, 1);
        }
      } else {
        // 如果没有 index，使用值查找
        const tagIndex = this.dynamicTags.indexOf(tag);
        if (tagIndex > -1) {
          this.dynamicTags.splice(tagIndex, 1);
          // 同步从 form.materialText 中移除
          if (this.form.materialText && Array.isArray(this.form.materialText)) {
            const textIndex = this.form.materialText.indexOf(tag);
            if (textIndex > -1) {
              this.form.materialText.splice(textIndex, 1);
            }
          }
        }
      }
    },
    /**
     * 兼容读取历史 content。
     * 老的线下物料把内容存成 [{content, attachmentFiles}] 的 JSON 串，
     * 现在统一成一段 HTML，读的时候把各模块顺序拼起来，不做数据迁移。
     */
    normalizeContent(raw) {
      if (!raw) return "";
      if (Array.isArray(raw)) {
        return raw.map(item => (item && item.content) || "").join("");
      }
      if (typeof raw !== "string") return "";
      const text = raw.trim();
      if (!text) return "";
      // 只有看着像 JSON 才 parse，普通 HTML 原样返回
      if (text.charAt(0) !== "[" && text.charAt(0) !== "{") return text;
      try {
        const parsed = JSON.parse(text);
        if (Array.isArray(parsed)) {
          return parsed.map(item => (item && item.content) || "").join("");
        }
        if (parsed && typeof parsed.content === "string") return parsed.content;
        if (typeof parsed === "string") return parsed;
        return "";
      } catch (e) {
        return text;
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.isParentid = false;
      this.form = initFormBean();
      this.activeType = 1;
      this.dynamicTags = [];
      this.inputVisible = false;
      this.inputValue = "";
      // 确保数组字段始终是数组
      this.form.materialImg = [];
      this.form.materialText = [];
      // 确保 content 是空字符串，而不是 null
      this.form.content = "";
      // 更新 editorKey 强制重新渲染 Editor 组件
      this.editorKey += 1;
         // 分享素材图片重置为空数组
         this.form.posterImg = [];
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm();
      if (row && row.id) {
        this.form.parentid = row.id;
        this.isParentid = true;
      }
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      // 获取 id，优先从 templateMaterialsSharePO 中获取
      const id =
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id) ||
        row.id;

      if (!id) {
        this.$message.error("缺少物料ID");
        return;
      }

      // 加载数据
      templateMaterialsShareApi
        .fetchById(id)
        .then(res => {
          const responseData = res.data || {};
          const sharePO =
            responseData.templateMaterialsSharePO || responseData || {};

          // 回填表单数据
          this.form = {
            ...this.form,
            ...sharePO,
            // 处理分类ID
            classificationId: sharePO.classificationId
              ? Number(sharePO.classificationId)
              : null,
            // 处理类型
            type: sharePO.type || 1
          };

          // 设置内容类型
          this.activeType = sharePO.type || 1;

          // 处理标题 JSON
          if (sharePO.titleJson) {
            try {
              const titleList =
                typeof sharePO.titleJson === "string"
                  ? JSON.parse(sharePO.titleJson)
                  : sharePO.titleJson;
              if (Array.isArray(titleList)) {
                this.dynamicTags = titleList
                  .map(item => item.titleName || item)
                  .filter(Boolean);
                // 同步到 materialText
                this.form.materialText = [...this.dynamicTags];
              }
            } catch (e) {
              console.error("解析标题失败:", e);
            }
          }

          // 处理素材数组
          if (sharePO.materialImg) {
            try {
              const parsedImg =
                typeof sharePO.materialImg === "string"
                  ? JSON.parse(sharePO.materialImg)
                  : sharePO.materialImg;
              // 确保是数组，并转换为组件需要的格式
              if (Array.isArray(parsedImg)) {
                this.form.materialImg = parsedImg.map((url, index) => {
                  // 如果已经是对象格式，直接返回
                  if (typeof url === "object" && url.url) {
                    return url;
                  }
                  // 如果是字符串，转换为对象格式
                  return {
                    url: url,
                    name: `image-${index}.jpg`,
                    uid: Date.now() + index
                  };
                });
              } else {
                this.form.materialImg = [];
              }
            } catch (e) {
              console.error("解析素材图片失败:", e);
              this.form.materialImg = [];
            }
          } else {
            this.form.materialImg = [];
          }

          if (sharePO.materialText) {
            try {
              const parsedText =
                typeof sharePO.materialText === "string"
                  ? JSON.parse(sharePO.materialText)
                  : sharePO.materialText;
              this.form.materialText = Array.isArray(parsedText)
                ? parsedText
                : [];
              // 同步到 dynamicTags
              if (Array.isArray(parsedText) && parsedText.length > 0) {
                this.dynamicTags = [...parsedText];
              }
            } catch (e) {
              this.form.materialText = [];
            }
          }
                  // 处理分享素材图片 posterImg（多张图片以英文逗号或JSON数组形式存）
                  if (sharePO.posterImg) {
                    try {
                      let posterImgSource = sharePO.posterImg;
                      let urlList = [];

                      if (typeof posterImgSource === "string") {
                        // 先尝试按 JSON 数组解析
                        try {
                          const parsed = JSON.parse(posterImgSource);
                          if (Array.isArray(parsed)) {
                            urlList = parsed;
                          } else {
                            // 不是数组，则按逗号分隔
                            urlList = posterImgSource
                              .split(",")
                              .map(item => item && item.trim())
                              .filter(Boolean);
                          }
                        } catch (e) {
                          // 不是 JSON，按逗号分隔
                          urlList = posterImgSource
                            .split(",")
                            .map(item => item && item.trim())
                            .filter(Boolean);
                        }
                      } else if (Array.isArray(posterImgSource)) {
                        urlList = posterImgSource;
                      }

                      if (Array.isArray(urlList) && urlList.length > 0) {
                        this.form.posterImg = urlList.map((item, index) => {
                          if (item && typeof item === "object" && item.url) {
                            return item;
                          }
                          const url = typeof item === "string" ? item : "";
                          return {
                            url,
                            name: `poster-${index}.jpg`,
                            uid: Date.now() + index
                          };
                        });
                      } else {
                        this.form.posterImg = [];
                      }
                    } catch (e) {
                      console.error("解析分享素材图片 posterImg 失败:", e);
                      this.form.posterImg = [];
                    }
                  } else {
                    this.form.posterImg = [];
                  }
          // 处理内容：线上/线下统一一段 HTML，历史的多模块 JSON 在这里拍平
          this.form.content = this.normalizeContent(sharePO.content);
          // 更新 editorKey 强制重新渲染 Editor 组件
          this.editorKey += 1;

          this.formVisible = true;
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        })
        .catch(err => {
          console.error("加载数据失败:", err);
          this.$message.error("加载数据失败");
        });
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      // 先进行表单验证
      this.$refs["dataForm"].validate(valid => {
        if (!valid) {
          return;
        }

        // 防止重复提交
        if (this.isRepSub) return;
        this.isRepSub = true;

        const params = JSON.parse(JSON.stringify(this.form));

        // 设置类型
        params.type = this.activeType;

        // 根据classificationId从backendTreeList中查找对应的code
        if (params.classificationId) {
          const code = this.findCodeById(this.menuOptions, params.classificationId);
          if (code) {
            params.classificationCode = code;
          }
        }

        // 处理标题：如果有多个标题，转换为 titleJson
        if (this.dynamicTags && this.dynamicTags.length > 0) {
          params.titleJson = JSON.stringify(
            this.dynamicTags.map(tag => ({
              titleName: tag,
              isEdit: 0
            }))
          );
        }

        // 处理素材数组：转换为 JSON 字符串
        // materialImg 是图片数组
        if (Array.isArray(params.materialImg)) {
          params.materialImg =
            params.materialImg.length > 0
              ? JSON.stringify(params.materialImg)
              : null;
        }
        // materialText 是文案数组，从 dynamicTags 同步
        if (this.dynamicTags && this.dynamicTags.length > 0) {
          params.materialText = JSON.stringify(this.dynamicTags);
        } else if (Array.isArray(params.materialText)) {
          params.materialText =
            params.materialText.length > 0
              ? JSON.stringify(params.materialText)
              : null;
        }

        // 处理 type 4 的课程章节数据
        if (this.activeType === 4) {
          // // 确保 courseSubjectId 存在
          // if (!params.courseSubjectId) {
          //   this.$message.error("请选择课程");
          //   this.isRepSub = false;
          //   return;
          // }
          // 处理章节列表，转换为 courseSubjectList 格式
          if (this.courseChapterList && this.courseChapterList.length > 0) {
            // 验证所有章节都已选择
            const hasEmptyChapter = this.courseChapterList.some(
              item => !item.chapterId
            );
            if (hasEmptyChapter) {
              this.$message.error("请选择所有章节名称");
              this.isRepSub = false;
              return;
            }
            // 转换为 courseSubjectList 数组格式，并转换为 JSON 字符串
            params.courseSubjectList = JSON.stringify(
              this.courseChapterList.map((item, index) => ({
                chapterId: item.chapterId,
                chaptersNum: index + 1,
                attachmentFiles: item.attachmentFiles || []
              }))
            );
          } else {
            this.$message.error("请至少添加一个章节");
            this.isRepSub = false;
            return;
          }
        } else if (Array.isArray(params.courseSubjectList)) {
          // 其他类型：如果是数组，转换为 JSON 字符串
          params.courseSubjectList =
            params.courseSubjectList.length > 0
              ? JSON.stringify(params.courseSubjectList)
              : null;
        }

         // 分享素材图片 posterImg：多张图片以英文逗号拼接 URL 字符串保存
      if (Array.isArray(params.posterImg) && params.posterImg.length > 0) {
              // posterImg 里是 MoreImageUpload 的文件对象数组，取 url 字段
              const urlList = params.posterImg
                .map(item => {
                  if (!item) return "";
                  if (typeof item === "string") return item.trim();
                  return (item.url || "").trim();
                })
                .filter(Boolean);
              params.posterImg = urlList.length > 0 ? urlList.join(",") : "";
            } else {
              params.posterImg = "";
            }

        // 处理内容：统一存一段 HTML 字符串（线上、线下都一样），
        // 不要再包成 JSON 数组 —— App 端按纯 HTML 渲染。
        params.content =
          typeof params.content === "string" ? params.content : "";

        // 处理数字字段
        const toInt = v => {
          if (v === undefined || v === null || v === "") return undefined;
          const n = Number(v);
          return Number.isNaN(n) ? undefined : n;
        };

        // 虚拟配置数据字段，如果为空则设置为0
        const virtualDataFields = [
          "browseNum",
          "likeNum",
          "collectNum",
          "forwardNum"
        ];
        virtualDataFields.forEach(k => {
          const v = toInt(params[k]);
          params[k] = v === undefined ? 0 : v;
        });

        const intFields = [
          "classificationId",
          "meetingId",
          "orderNo",
          "state",
          "teacherId",
          "teacherIsEdit",
          "canDownloadMaterial",
          "courseSubjectId",
          "type"
        ];

        intFields.forEach(k => {
          const v = toInt(params[k]);
          if (v === undefined) {
            delete params[k];
          } else {
            params[k] = v;
          }
        });

        // 新增时 id 传 null
        if (!params.id) {
          params.id = null;
        }

        // 清理 undefined 和 null 值（但保留空字符串，因为某些字段可能需要）
        Object.keys(params).forEach(key => {
          if (params[key] === undefined || params[key] === null) {
            delete params[key];
          }
        });

        console.log("提交参数:", params);

        const req = params.id
          ? templateMaterialsShareApi.update(params)
          : templateMaterialsShareApi.create(params);

        req
          .then(data => {
            this.postCallback(data);
          })
          .catch(res => {
            this.isRepSub = false;
            console.error("操作失败:", res);
            this.$message.error(res.message || "操作失败");
          });
      });
    },
    postCallback(response) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.$emit("created");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}

.content-type-btn {
  background-color: #f8f8f8;
  border-color: #c5c5c5;
  color: #606266;

  &:hover {
    background-color: #ecf4fd;
    border-color: #3a8ee6;
    color: #3a8ee6;
  }

  &.active {
    background-color: #ecf4fd;
    border-color: #3a8ee6;
    color: #3a8ee6;

    &:hover {
      background-color: #ecf4fd;
      border-color: #3a8ee6;
      color: #3a8ee6;
    }
  }
}

.virtual-data-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;

  .el-input {
    font-size: 12px;

    ::v-deep .el-input__inner {
      font-size: 12px;
    }
  }
}
.el-tag {
  margin-right: 6px;
}

.course-info-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.course-info-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  flex-shrink: 0;
}

.course-attachment-tip {
  color: #f56c6c;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 10px;
}

.table-list {
  border: 1px solid #e4e4e4;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;
    &.flex05 {
      flex: 0.5;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 18px;
    color: #465c99;
    font-weight: 600;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}

// 确保课程选择器的下拉箭头显示
::v-deep .el-select {
  .el-input__suffix {
    .el-select__caret {
      display: inline-block;
      visibility: visible;
    }
  }
}
</style>
